import styled, { css } from "styled-components"

import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
// import Link from "~/components/atoms/Link"
import { Container as _Container } from "~/components/layouts/Container"
import { Color, IsMobile, IsPC, LineHeight, RadiusSize, Shadow, SpacingSize, TextSize } from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

const LearningStyle = () => {
  return (
    <Container size="Large">
      <Pc>
        <img src={staticPath("/static/images/course/learning-style-pc.svg")} />
      </Pc>
      <Sp>
        <img src={staticPath("/static/images/course/learning-style-sp.svg")} />
      </Sp>
      <p className="heading">初心者・未経験者でも安心の学習スタイル</p>
      <p className="supplement">受け身の講義だけでなく、実践ワークや質問し放題の環境で学習の理解・定着を促進します</p>
      <StyledLearningStyle>
        <StyledLearningStyleItem>
          <StyledLearningStyleItemIcon src={staticPath("/static/images/course/online-education.svg")} />
          <StyledLearningStyleItemTextArea>
            <StyledLearningStyleItemTextAreaHeading>オンライン講義形式</StyledLearningStyleItemTextAreaHeading>
            <StyledLearningStyleItemTextAreaCaption type="Body">
              リアルタイムで講義を実施。講義中に簡単な実践/ワークも実施します。
            </StyledLearningStyleItemTextAreaCaption>
          </StyledLearningStyleItemTextArea>
        </StyledLearningStyleItem>
        <StyledLearningStyleItem>
          <StyledLearningStyleItemIcon src={staticPath("/static/images/course/chat.svg")} />
          <StyledLearningStyleItemTextArea>
            <StyledLearningStyleItemTextAreaHeading>チャットで質問し放題</StyledLearningStyleItemTextAreaHeading>
            <StyledLearningStyleItemTextAreaCaption type="Body">
              受講期間中はいつでも講師にチャットで質問いただけます。学習での不明点や躓いた点などを解消します。
            </StyledLearningStyleItemTextAreaCaption>
          </StyledLearningStyleItemTextArea>
        </StyledLearningStyleItem>
      </StyledLearningStyle>
    </Container>
  )
}

const Container = styled(_Container)`
  ${IsPC(css`
    padding: 96px 16px;
  `)}
  ${IsMobile(css`
    padding: 48px 16px;
  `)}
  .heading {
    font-size: ${TextSize["2XL"]}px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-top: ${SpacingSize["4XL"]}px;
    ${IsMobile(css`
      font-size: 20px;
      margin-top: 32px;
    `)}
  }
  .supplement {
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.L}%;
    color: ${Color.Gray};
    margin-top: ${SpacingSize["3XS"]}px;
    ${IsMobile(css`
      margin-top: 8px;
    `)}
  }
`
const StyledLearningStyle = styled.div`
  display: flex;
  margin-top: ${SpacingSize["4XL"]}px;
  justify-content: space-evenly;
  ${IsMobile(css`
    flex-direction: column;
    margin-top: 32px;
  `)}
`
const StyledLearningStyleItem = styled.div`
  width: calc(33% - 32px);
  ${Shadow.Deep};
  border-radius: ${RadiusSize.Medium}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${SpacingSize["4XL"]}px ${SpacingSize.XL}px ${SpacingSize["2XL"]}px;
  margin-bottom: ${SpacingSize.L}px;
  ${IsMobile(css`
    width: 100%;
    margin-bottom: 24px;
  `)}
  &:not(:first-child) {
    margin-left: 48px;
    ${IsMobile(css`
      margin-left: 0;
    `)}
  }
`
const StyledLearningStyleItemIcon = styled.img`
  width: auto;
  height: 80px;
`
const StyledLearningStyleItemTextArea = styled.div`
  margin-top: ${SpacingSize["2XL"]}px;
  text-align: center;
`

const StyledLearningStyleItemTextAreaHeading = styled.p`
  font-size: ${TextSize.L}px;
  font-weight: bold;
  line-height: ${LineHeight.S}%;
`
const StyledLearningStyleItemTextAreaCaption = styled(Typography)`
  color: ${Color.Gray};
  margin-top: ${SpacingSize["3XS"]}px;
`

export default LearningStyle
